export enum CharityScreenState {
  GeneralInfo = 1,
  QRCodeSettings = 2,
  StripeConnect = 3,
  SupportersReport = 4,
  DateRangeReporting = 5,
  DrawReporting = 6
}
